import { IPage, ISearchPage } from '@/types/AppTypes'
import { httpRequest } from '@/utils/HttpRequest'




export interface IAssetsDetailSearchFields extends ISearchPage {
    code?: string
    name?: string
}

//详情
export interface IAssetsArchivesDetail {
    id?: string
    code?: string
    name?: string
    intervalMileage?: string
    warningMileage?: string
    vehicleBrandCode?: string
    vehicleBrandName?: string
    vehicleModelCode?: string
    vehicleModelName?: string
    assetsAmount?: number
    itemAmount?: number
    disableFlag?: string
    remark?: string
    createTime?: string
    createUser?: string
    [key: string]: any
}

//搜索条件
export interface IAssetsArchivesSearchFields {
    code?: string
    name?: string
    vehicleBrandCode?: string
    vehicleModelCode?: string
}

export interface IAssetsArchivesSearch extends IAssetsArchivesSearchFields, ISearchPage {
    shopId?: string
    shopCode?: string
}

export interface IpositionSearch extends IAssetsArchivesSearchFields, ISearchPage {}


class AssetsArchivesService {
    async page(searchVo: IAssetsArchivesSearch, config: object = {}) {
        const apiUrl = 'assets/base/material/page'
        return await httpRequest.post<IPage<IAssetsArchivesDetail>>(apiUrl, searchVo, config)
    }
}

export const assetsArchivesService = new AssetsArchivesService()
